export default {
  page: {
    htmlTitle: 'Claudia Wegener',
    description: 'Beratung Bildungskommunikation',
    keywords: ['Bildungskommunikation', 'Beratung', 'Kita', 'Schule', 'Erzieher', 'Kinder', 'Außerschulische Lernorte', 'Eltern', 'Pädagogen', 'Lehrer', 'Jugendliche'],
    author: 'Wolfger Schramm <wolfger@spearwolf.de>',
  },
};
